'use client';

import { use } from 'react';
import { ArticleSectionRelated } from '@/app_components/ArticleSections/ArticleSectionRelated';
import type { ArticlePreview } from '@/app_lib/types/ArticlePreview';
import type { EventData } from '@/app_lib/types/Gtm';

const trackingData: EventData = {
  // biome-ignore lint/style/useNamingConvention: gtm data
  contentPlacementCD: 'most popular - bottom',
  eventAction: 'most popular module click',
  eventCategory: 'navigation',
};

export const MostPopular = ({ articlesPromise }: { articlesPromise: Promise<ArticlePreview[]> }) => {
  const articles = use(articlesPromise);

  return (
    <ArticleSectionRelated
      articles={articles}
      heading='Most Popular'
      trackingData={trackingData}
    />
  );
};
